<template>
    <div class="marquee_box" id="marquee" :style="marqueeStyle">
        <div class="marquee_warp">
            <span class="text">{{text}}</span>
        </div>
        <div class="act-btn">
            <img v-if="type == 0" class="tips-pic" @click="closeNotice" src="https://file.40017.cn/tcservice/wxapp/chat/image/x.png">
            <navigator hover-class="none" url="/page/pubBusiness/views/indents/filtrate/filtrate" class="query-btn" v-else>查询订单</navigator>
        </div>
    </div>
</template>

<script>
export default {    
    props:{
        text: String,
		type: null,
        hasCustomHeader: Boolean,
        hasSortHeader:Boolean,
        topP:String            
    },
    data(){
        return {
            marqueeStyle:""
        }
    },        
    methods: {
		closeNotice() {            			
            this.$emit('marquee',{type: 'CLOSE'})
		},
		getNodeInfo() {
            let marque=document.getElementById("marquee")
            this.$emit('marquee',{type: 'INFO',
					height: marque.offsetHeight || 0})			
		},
        setMarqueeMarginTop(){                  
            var top=0;     
            if (this.hasCustomHeader === true )// && getApp().globalData.hideNavBar === false)
            {        
                top= getApp().globalData.totalNavHeightNew
            }
            if (this.hasSortHeader){
                top += 40
            }
            let topstyle = "margin-top:" + top + "px;"
            this.marqueeStyle=topstyle              
        }
    },
	mounted() {   
      console.log("mounted")
	  this.getNodeInfo()
      //检查自定义头部是否显示，有显示的话，加一个margin-top的样式。 H5 先不检查
      // this.setMarqueeMarginTop()       
      if (!!this.topP) {        
        this.marqueeStyle =this.marqueeStyle + this.topP        
      }      
   }
}

</script>

<style scoped>
.marquee_box {
    position: fixed;
    left: 0;
    right: 0;
	top: 40px;
    display: flex;
	align-items: center;
    justify-content: space-between;
    background: #fef5eb;
	padding: 0 15px;
	overflow: hidden;
	z-index: 99;
	box-shadow: 0px 5px 10px 0px rgba(54,56,72, 0.05);
    height: fit-content;
}
.marquee_warp {
	position: relative;
	flex: 1;
	margin-right: 15px;
	padding: 12.5px 0;
}
.text {
    display: block;  
    font-size: 13px;
    color: #c1913a;
    line-height: 1.1em;
    text-align: left !important;
}
.tips-pic {
	display: block;
    width: 12px;
    height: 12px;
    padding: 10px;
}
.act-btn {
	display: block;
    font-size: 13px;
}
.query-btn {
	width: 70px;
	height: 25px;
	white-space: nowrap;
	font-size: 13px;
	box-shadow: 0 0 0 1px rgba(193,145,58,0.5);
	color: #c1913a;
	border-radius: 12.5px;
	text-align: center;
	line-height: 25px;
}
.notice-icon {
	width:20px;
	height:20px;
	background:url("https://file.40017.cn/travelassistant/static/miniProgram/trip_tips_icon@2x.png") center no-repeat;
	background-size:contain;
}
</style>


// WEBPACK FOOTER //
// src/components/notice.vue